import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { SessionService } from '@core/services/session.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-inactivity-logout-banner',
  templateUrl: './inactivity-logout-banner.component.html',
  styleUrls: ['./inactivity-logout-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TranslatePipe]
})
export class InactivityLogoutBannerComponent {
  // shown once per auto-logout, until dismissed or the page is reloaded
  visible: boolean;

  constructor(private readonly sessionService: SessionService) {
    this.visible = this.sessionService.consumeAutoLogoutFlag();
  }

  dismiss(): void {
    this.visible = false;
  }
}
